export enum CommonEnums {
  SEND_TIP_AMOUNT = 'Send Tip Amount',
  OR = 'OR',
  GUEST = 'guest',
  LOGIN_SIGN_UP = 'loginSignUp',
  LOGGED = 'logged',
  STATIC = 'static',
  VISIBLE_WITH_TIP = '(it will be visible with tip)',
  VISIBLE_IN_COMMENTS = '(it will be visible in comments)',
  TIP = 'tip',
  PROFILE = 'profile',
  BANNER = 'banner',
  CREATE_ACCOUNT_SIGN_IN = 'CREATE ACCOUNT/SIGN IN',
  TIP_AS_GUEST = 'TIP AS GUEST',
  BACK_TO_TIP_MODAL = 'backToTipModal',
  BUTTON = 'button',
  VIEW_SUBSCRIPTION_PLAN = 'View Subscription Plans',
  ADD_APP_TO_HOME_SCREEN = 'Tap to Install this site as an App.',
  INSTALL_WEBAPP_IN_IPHONE = 'Install TopFan as an App: Tap the',
  INSTALL_WEBAPP_IN_IPHONE_WLS = 'Install this site as an App: Tap the',
  ICON_AND = '  icon and',
  ADD_TO_HOME = ' Add to Home Screen.'
}

export enum ApplicationStatusEnums {
  APPROVED = 'approve',
  FAILED = 'reject',
  PENDING = 'pending',
  RESUBMIT = 'resubmission_requested'
}

export enum PERMISSION_TYPE {
  READ = 'READ',
  WRITE = 'WRITE'
}

export enum CarouselOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}
